const transFunction = (targets = [], type = '', matchMap) => {
  const translate = [];
  const regex = new RegExp(`\\#${type}\\(.*?\\)`, 'g');
  const regexClear = new RegExp(`\\#${type}|[|\\(|\\)]`, 'g');

  targets.forEach((target) => {
    if (typeof target === 'string') {
      const match = target.match(regex);

      if (match) {
        const typing = match.map((m) => matchMap(m, regexClear));

        const split = target.split(regex);

        for (let index = 0; index < split.length; index += 1) {
          if (split[index] !== undefined) {
            translate.push(split[index]);
          }
          if (typing[index] !== undefined) {
            translate.push(typing[index]);
          }
        }
      } else {
        translate.push(target);
      }
    } else {
      translate.push(target);
    }
  });

  return translate;
};

export default transFunction;
